import { render, staticRenderFns } from "./MembershipHistoryPopup.vue?vue&type=template&id=8a07b9ce&scoped=true&"
import script from "./MembershipHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./MembershipHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a07b9ce",
  null
  
)

export default component.exports